import { z } from 'zod';
/**
 * Primitives partagées par l'ensemble des contrats.
 *
 * Ce paquet est la seule source de vérité du vocabulaire échangé entre l'API et
 * le client web : toute évolution de forme se fait ici, jamais des deux côtés.
 */
/** Identifiant technique (UUID v4/v7) de toute entité persistée. */
export const idSchema = z.string().uuid('Identifiant invalide');
/**
 * Date-heure ISO 8601 en UTC.
 *
 * Volontairement validée par `Date.parse` plutôt que par un format strict :
 * les horodatages proviennent aussi bien de PostgreSQL que du navigateur, et
 * un refus sur une variante de format légitime coûterait plus qu'il ne protège.
 */
export const isoDateTimeSchema = z
    .string()
    .refine((value) => !Number.isNaN(Date.parse(value)), 'Date-heure ISO invalide');
/** Date calendaire `AAAA-MM-JJ`, sans composante horaire. */
export const isoDateSchema = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Date attendue au format AAAA-MM-JJ');
export const MAX_PAGE_SIZE = 200;
export const DEFAULT_PAGE_SIZE = 25;
/** Paramètres de pagination communs à toutes les collections exposées. */
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
});
export function pageOf(items, total, query) {
    return {
        items,
        page: query.page,
        pageSize: query.pageSize,
        total,
        totalPages: Math.max(1, Math.ceil(total / query.pageSize)),
    };
}
export const sortDirectionSchema = z.enum(['asc', 'desc']);
/** Codes d'erreur métier stables, utilisés par le client pour réagir finement. */
export const ERROR_CODES = {
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    UNAUTHENTICATED: 'UNAUTHENTICATED',
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
    ACCOUNT_DISABLED: 'ACCOUNT_DISABLED',
    FORBIDDEN: 'FORBIDDEN',
    BRANCH_SCOPE_VIOLATION: 'BRANCH_SCOPE_VIOLATION',
    NOT_FOUND: 'NOT_FOUND',
    CONFLICT: 'CONFLICT',
    DUPLICATE_RECEIPT: 'DUPLICATE_RECEIPT',
    INVALID_LOT_TRANSITION: 'INVALID_LOT_TRANSITION',
    LOT_NOT_EDITABLE: 'LOT_NOT_EDITABLE',
    UNSUPPORTED_MEDIA_TYPE: 'UNSUPPORTED_MEDIA_TYPE',
    PAYLOAD_TOO_LARGE: 'PAYLOAD_TOO_LARGE',
    RATE_LIMITED: 'RATE_LIMITED',
    STORAGE_FAILURE: 'STORAGE_FAILURE',
    OCR_FAILURE: 'OCR_FAILURE',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
};
//# sourceMappingURL=primitives.js.map